import { formatEntityName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const uniqueStmtInstruction = `
### Constraints

#### Making fields unique
- Syntax: \`unique <entity_name> <column_name>;\`
- Example: \`unique Car registrationPlace;\``;
export const stmtSetUnique = ({ entityName, fields }) => {
    return `unique ${entityName} ${fields.join(', ')};`;
};
export const stmtForHumanSetUnique = ({ entityName, fields }) => {
    return `Make the fields __${fields.join(', ')}__ unique in the database table __${entityName}__.`;
};
export const uniqueHandler = createSchemaStatementHandler({
    type: 'unique',
    parse: line => {
        const match = /^unique (?<entityName>\w+)[ .](?<fields>[\w, ]+)/.exec(line);
        return match?.groups
            ? {
                type: 'unique',
                entityName: formatEntityName(match.groups.entityName),
                fields: match.groups.fields.split(', ').map(s => s.trim()),
            }
            : null;
    },
    getHumanStmt: (stmt) => stmtForHumanSetUnique(stmt),
    apply: (stmt, builder) => {
        builder.updateSchema(it => it.createUnique(stmt.entityName, { fields: stmt.fields }));
    },
});
//# sourceMappingURL=UniqueStmt.js.map